export { default as leSoir } from './le-soir.svg'
export { default as leFigaro } from './le-figaro.svg'
export { default as marieClaire } from './marie-claire.svg'
export { default as trends } from './trends.svg'
export { default as bilan } from './bilan.svg'
export { default as france24 } from './france-24.svg'
export { default as lesEchos } from './les-echos.svg'
export { default as laLibre } from './la-libre.svg'
